/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited
 * SPDX-License-Identifier: Apache-2.0
 */

import { useEffect } from 'react';

export function useBrandFavicon(faviconUrl?: string) {
  useEffect(() => {
    const href = faviconUrl?.trim();
    if (!href) {
      return;
    }

    const icons = Array.from(
      document.head.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]'),
    );
    const link = icons[0] ?? document.createElement('link');
    link.rel = 'icon';
    link.href = href;
    // Build-time metadata may not describe the administrator's uploaded icon.
    link.removeAttribute('type');
    link.removeAttribute('sizes');
    link.removeAttribute('media');
    if (!link.isConnected) {
      document.head.appendChild(link);
    }

    // Browsers can reselect another candidate after SPA navigation. Keep only
    // the configured favicon; touch icons and other head links are unrelated.
    icons.slice(1).forEach(icon => icon.remove());
  }, [faviconUrl]);
}
